import React, { useEffect } from 'react';

const Modal = ({ open, title, onClose, children }) => {
	useEffect(() => {
		if (!open) return;
		const handleKey = (e) => { if (e.key === 'Escape') onClose?.(); };
		window.addEventListener('keydown', handleKey);
		return () => window.removeEventListener('keydown', handleKey);
	}, [open, onClose]);

	if (!open) return null;

	return (
		<div className="modal-overlay" role="dialog" aria-modal="true" onClick={(e)=>{ if (e.target === e.currentTarget) onClose?.(); }}>
			<div className="modal-card" role="document" onClick={(e)=>e.stopPropagation()}>
				<div className="modal-header">
					<h3 className="modal-title">{title}</h3>
					<button className="close-btn" aria-label="Cerrar" onClick={onClose}>×</button>
				</div>
				<div className="modal-body">
					{children}
				</div>
			</div>
		</div>
	);
};

export default Modal;
